"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.KnockNotificationItem = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _KnockNotificationItem = require("./KnockNotificationItem.styled");
var _KnockItems = require("../../KnockItems");
var _KnockTypes = require("../../../../constants/KnockTypes");
var _knockTypeComponents;
var KnockNotificationItem = exports.KnockNotificationItem = function KnockNotificationItem(_ref) {
  var knock = _ref.knock,
    onApprove = _ref.onApprove,
    onDeny = _ref.onDeny,
    sources = _ref.sources,
    maxCamerasExceeded = _ref.maxCamerasExceeded,
    onAVClicked = _ref.onAVClicked,
    isDisabled = _ref.isDisabled;
  var Component = knockTypeComponents[knock.type];
  if (typeof maxCamerasExceeded !== 'boolean') maxCamerasExceeded = false;
  return /*#__PURE__*/_react["default"].createElement(_KnockNotificationItem.KnockNotificationItemContainer, null, /*#__PURE__*/_react["default"].createElement(_KnockNotificationItem.KnockNotificationItemContent, null, /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, knock, {
    onApprove: onApprove,
    onDeny: onDeny,
    sources: sources,
    maxCamerasExceeded: maxCamerasExceeded,
    onAVClicked: onAVClicked,
    isDisabled: isDisabled
  }))));
};
KnockNotificationItem.propTypes = {
  knock: _propTypes["default"].shape({
    _id: _propTypes["default"].string,
    name: _propTypes["default"].string,
    type: _propTypes["default"].string,
    socketId: _propTypes["default"].string,
    isCameraOn: _propTypes["default"].bool,
    isMicrophoneOn: _propTypes["default"].bool
  }),
  onApprove: _propTypes["default"].func.isRequired,
  onDeny: _propTypes["default"].func.isRequired,
  sources: _propTypes["default"].array,
  maxCamerasExceeded: _propTypes["default"].bool,
  onAVClicked: _propTypes["default"].func,
  liveCameras: _propTypes["default"].number,
  isDisabled: _propTypes["default"].bool
};
var _default = exports["default"] = KnockNotificationItem;
var knockTypeComponents = (_knockTypeComponents = {}, (0, _defineProperty2["default"])(_knockTypeComponents, _KnockTypes.SCREENSHARE, _KnockItems.ScreenShareKnockItem), (0, _defineProperty2["default"])(_knockTypeComponents, _KnockTypes.PRESENTER, _KnockItems.PresenterKnockItem), _knockTypeComponents);